import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PublicFormService } from '../../../services/public-form.service';
import { NO_PHOTO, fallbackToNoPhoto } from '../../../shared/utils/no-photo';

@Component({
  selector: 'app-annuaire-detail',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './annuaire-detail.html',
  styleUrl: './annuaire-detail.css',
})
export class AnnuaireDetailComponent implements OnInit {
  /** Image par défaut des annuaires, en l'absence de photo. */
  readonly noPhoto = NO_PHOTO;
  readonly onImgError = fallbackToNoPhoto;

  profile: any = null;
  loading = true;
  error = '';
  type: 'influencer' | 'agency' | 'calligraphe' = 'influencer';

  get displayName(): string {
    return this.profile?.display_name || this.profile?.agency_name || '';
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private publicFormService: PublicFormService,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id')!;
    const segment = this.route.snapshot.url[1]?.path ?? '';

    // Le segment d'URL détermine le type de fiche affichée.
    this.type = segment === 'agence'      ? 'agency'
              : segment === 'calligraphe' ? 'calligraphe'
              : 'influencer';

    const obs = this.type === 'agency'      ? this.publicFormService.getAgency(id)
              : this.type === 'calligraphe' ? this.publicFormService.getCalligrapher(id)
              : this.publicFormService.getInfluencer(id);

    obs.subscribe({
      next: (data: any) => {
        this.profile = data;
        this.loading = false;
      },
      error: () => {
        this.error = this.translate.instant('annuaire_det_introuvable');
        this.loading = false;
      },
    });
  }

  goBack(): void {
    this.router.navigate(['/annuaire']);
  }

  formatNum(n: number | null | undefined): string {
    if (!n) return '—';
    if (n >= 1_000_000) return (n / 1_000_000).toFixed(1) + 'M';
    if (n >= 1_000) return (n / 1_000).toFixed(0) + 'K';
    return String(n);
  }

  platformIcon(p: string): string {
    const m: Record<string, string> = {
      instagram: '📷', tiktok: '🎵', youtube: '▶️',
      twitter: '𝕏', facebook: '📘', snapchat: '👻',
      linkedin: '💼', autre: '🌐',
    };
    return m[p] || '🌐';
  }

  platformLabel(p: string): string {
    const m: Record<string, string> = {
      instagram: 'Instagram', tiktok: 'TikTok', youtube: 'YouTube',
      twitter: 'X (Twitter)', facebook: 'Facebook', snapchat: 'Snapchat',
      linkedin: 'LinkedIn', autre: 'Autre',
    };
    return m[p] || p;
  }

  licenseColor(status: string): string {
    const m: Record<string, string> = {
      approved: 'green', payment_complete: 'blue',
      license_suspended: 'orange', license_revoked: 'red',
    };
    return m[status] || 'gray';
  }

}
